import type { myFetchOptions } from './request';

export type DriverInfo = {
    attrType: number;
    driverName: string;
};

export const driverMap: DriverInfo[] = [
    { attrType: 2000, driverName: "所有网盘" },
    { attrType: 2002, driverName: "阿里云盘" },
    { attrType: 2003, driverName: "百度网盘" },
    { attrType: 2004, driverName: "夸克网盘" },
    { attrType: 2005, driverName: "迅雷网盘" },
    { attrType: 2006, driverName: "天翼网盘" },
    { attrType: 2007, driverName: "123网盘" },
    { attrType: 2008, driverName: "移动网盘" },
    { attrType: 2009, driverName: "UC网盘" },
    { attrType: 2010, driverName: "115网盘" },
];

export const $api_Source_AddSource = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Source/AddSource', opt)
}
export const $api_Source_GetMySourceByPage = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Source/GetMySourceByPage', opt)
}
export const $api_Source_DeleteSouceById = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Source/DeleteSouceById', opt)
}

export const $api_Source_ModifySourceTitle = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Source/ModifySourceTitle', opt)
}

export const api_Source_GetSourceByPage = (opt: myFetchOptions) => {
    return useHttpFetch('/api/Source/GetSourceByPage', opt)
}

export const $api_Source_GetSourceByPage = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Source/GetSourceByPage', opt)
}
export const api_Source_GetSouceById = (opt: myFetchOptions) => {
    return useHttpFetch('/api/Source/GetSouceById', opt)
}

export const $api_Source_Action = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Source/Action', opt)
}

export const $api_Source_FreePaySource = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Source/FreePaySource', opt)
}

export const $api_Source_PaySource = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Source/PaySource', opt)
}

export const $api_Source_GetUserBrowserRecords = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Source/GetUserBrowserRecords', opt)
}

export const $api_Source_GetMyPayRecordsByPage = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Source/GetMyPayRecordsByPage', opt)
}